import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LandingNavbarComponent } from '../../shared/landing-navbar/landing-navbar.component';
import { LandingFooterComponent } from '../../shared/landing-footer/landing-footer.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, LandingNavbarComponent, LandingFooterComponent],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  private autoScrollInterval: any;
  private scrollSpeed = 1; // pixels per frame
  private scrollPosition = 0;

  featureCards = [
    {
      icon: 'assets/icons/add.svg',
      heading: 'Create Your Ad',
      content: 'Set up your ad campaign in minutes - no paperwork or contracts'
    },
    {
      icon: 'assets/icons/preference.svg',
      heading: 'Easily Create & Customize Your Ad',
      content: 'Record your ad right in the platform, upload one you already have, or we\'ll help you create one for free.'
    },
    {
      icon: 'assets/icons/timeclock.svg',
      heading: 'Save Time & Do It Yourself',
      content: 'Do it all yourself without needing to talk to a salesperson, hire an outside agency, or train your staff.'
    },
    {
      icon: 'assets/icons/upload.svg',
      heading: 'Get On The Air Quickly',
      content: 'Submit your campaign today and your ad could start playing within 24 hours.'
    },
    {
      icon: 'assets/icons/listener.svg',
      heading: 'Reach Listeners in Your Community',
      content: 'Connect with real people in real moments - while they\'re driving, working, or relaxing - and not distracted by screens.'
    },
    {
      icon: 'assets/icons/card6.svg',
      heading: 'Run Ads On Your Terms',
      content: 'Connect with real people in real moments - while they\'re driving, working, or relaxing - and not distracted by screens.'
    },
    {
      icon: 'assets/icons/wifi.svg',
      heading: 'Access Trusted Local Stations',
      content: 'Get heard on the stations your customers already know and love.'
    },
    {
      icon: 'assets/icons/checkmark.svg',
      heading: 'Choose When Your Ads Run',
      content: 'You decide exactly when your ads play - start date, end date, days, and times.'
    },
    {
      icon: 'assets/icons/budget.svg',
      heading: 'Set a Budget That Works for You',
      content: 'Set up your ad campaign in minutes, no paperwork or contracts'
    },
    {
      icon: 'assets/icons/card10.svg',
      heading: 'Know When Your Ads Air',
      content: 'Record your ad right in the platform, upload one you already have, or we\'ll help you create one for free.'
    }
  ];

  // Duplicate cards for seamless infinite scroll
  get duplicatedCards() {
    return [...this.featureCards, ...this.featureCards];
  }

  ngOnInit() {
    // Clear campaign builder state when entering home page
    localStorage.removeItem("campaignBuilderState");
    localStorage.removeItem("campaignPreview");
    localStorage.removeItem("campaignRequest");
    localStorage.removeItem("campaignPreviewDetails");

    this.startAutoScroll();
  }

  ngOnDestroy() {
    this.stopAutoScroll();
  }

  private startAutoScroll() {
    this.autoScrollInterval = setInterval(() => {
      this.scrollPosition += this.scrollSpeed;

      const carouselTrack = document.querySelector('.carousel-track') as HTMLElement;
      if (carouselTrack) {
        const cardWidth = 300; // 280px card + 20px gap
        const totalWidth = cardWidth * this.featureCards.length;

        // Reset position when we've scrolled through all original cards
        if (this.scrollPosition >= totalWidth) {
          this.scrollPosition = 0;
        }

        carouselTrack.style.transform = `translateX(-${this.scrollPosition}px)`;
      }
    }, 16); // ~60fps
  }

  private stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
    }
  }
}
